var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 14.285,
    viewBox: "0 0 12.5 14.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-building",
    "data-name": "Icon awesome-building",
    d: "M12.165,13.393h-.558V.67a.67.67,0,0,0-.67-.67H1.562a.67.67,0,0,0-.67.67V13.393H.335A.335.335,0,0,0,0,13.728v.558H12.5v-.558A.335.335,0,0,0,12.165,13.393ZM3.571,2.121a.335.335,0,0,1,.335-.335H5.022a.335.335,0,0,1,.335.335V3.237a.335.335,0,0,1-.335.335H3.906a.335.335,0,0,1-.335-.335Zm0,2.679a.335.335,0,0,1,.335-.335H5.022a.335.335,0,0,1,.335.335V5.915a.335.335,0,0,1-.335.335H3.906a.335.335,0,0,1-.335-.335ZM5.022,8.928H3.906a.335.335,0,0,1-.335-.335V7.478a.335.335,0,0,1,.335-.335H5.022a.335.335,0,0,1,.335.335V8.594A.335.335,0,0,1,5.022,8.928Zm2.121,4.464H5.357V11.049a.335.335,0,0,1,.335-.335H6.808a.335.335,0,0,1,.335.335Zm1.786-4.8a.335.335,0,0,1-.335.335H7.478a.335.335,0,0,1-.335-.335V7.478a.335.335,0,0,1,.335-.335H8.594a.335.335,0,0,1,.335.335Zm0-2.679a.335.335,0,0,1-.335.335H7.478a.335.335,0,0,1-.335-.335V4.8a.335.335,0,0,1,.335-.335H8.594a.335.335,0,0,1,.335.335Zm0-2.679a.335.335,0,0,1-.335.335H7.478a.335.335,0,0,1-.335-.335V2.121a.335.335,0,0,1,.335-.335H8.594a.335.335,0,0,1,.335.335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.35d12db7.svg";
export { ForwardRef as ReactComponent };